export function required_with(parameters, fields) {
  return {
    values: parameters.map(key => fields[key] || key).join(', ')
  };
}
